export async function post(url, params) {
  try {
    let response = await fetch(url, {
      method: "POST",
      body: params,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    let _data = await response.json();
    return _data;
    
  } catch (e) {
    console.log("error", e);
  }
}

export const chipsGroupDefault = [
  {
    id: "FAM",
    iconName: "spese-familiari",
    title: "Spese Familiari",
    cod: "45",
  },
  {
    id: "AUT",
    iconName: "auto",
    title: "Auto nuova",
    cod: "15",
  },
  {
    id: "AUU",
    iconName: "auto-usata",
    title: "Auto usata",
    cod: "16",
  },
  {
    id: "SME",
    iconName: "spese-mediche",
    title: "Spese mediche",
    cod: "46",
  },
  {
    id: "RIS",
    iconName: "home",
    title: "Ristrutturazione",
    cod: "12",
  },
  {
    id: "ARR",
    iconName: "beni-casa",
    title: "Acquisto beni per la casa",
    cod: "2",
  },
];